import { FormGridAreas } from 'modules/contactLookup/types';
import styled from 'styled-components';
import { spacing } from 'ui/theme';

import { useFormContext } from '../../contexts/FormContext';
import { LookupTypeRadio } from './LookupTypeRadio';

const Wrapper = styled.ul`
  grid-area: ${FormGridAreas.lookupTypeRadioList};
  padding: 0;
  margin: 0;
  height: ${spacing.plusQuarter};

  li {
    margin-right: ${spacing.plusHalf};

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

export const LookupTypeRadioList = () => {
  const { availableLookupTypes } = useFormContext();
  return (
    <Wrapper data-test="lookup-type-radio-list">
      {availableLookupTypes.map((lookupType) => (
        <LookupTypeRadio lookupType={lookupType} key={lookupType} />
      ))}
    </Wrapper>
  );
};
